export * from './configuration.service';
import { ConfigurationService } from './configuration.service';
export * from './dMP.service';
import { DMPService } from './dMP.service';
export * from './session.service';
import { SessionService } from './session.service';
export * from './vitale.service';
import { VitaleService } from './vitale.service';
export const APIS = [ConfigurationService, DMPService, SessionService, VitaleService];
